import React from 'react'

import cn from 'classnames'

import { FormLabel } from 'components/Typography'
import ScreenReaderOnlyText from 'helpers/ScreenReaderOnlyText/ScreenReaderOnlyText'

import styles from './BaseInputLabel.module.scss'
import { BaseInputLabelProps } from './types'

const BaseInputLabel: React.FC<BaseInputLabelProps> = ({
  children,
  name,
  id,
  isRequired,
  isDisabled,
  isLabelVisible = true,
}) =>
  isLabelVisible ? (
    <FormLabel
      htmlFor={id || name}
      className={cn(styles.label, isDisabled && styles.label_disabled)}
      isRequired={isRequired}
    >
      {children}
    </FormLabel>
  ) : (
    <ScreenReaderOnlyText Tag="label" htmlFor={id || name}>
      {children}
    </ScreenReaderOnlyText>
  )

export default BaseInputLabel
